import styled from "@emotion/styled";

const MyDiv = styled.div`

.lead_table{
  border:1px solid #E4E7EC;
  border-radius:8px;
  overflow:hidden;
  margin-top:12px;
}

/* HEADER */
.table_header{
  background:#F2F4F7;
  padding:12px 16px;
  border-bottom:1px solid #E4E7EC;
}

.col_field{
  width:40%;
  font-weight:600;
  color:#344054;
}

.col_value{
  width:60%;
  color:#475467;
  display:flex;
  align-items:center;
}

/* ROW */
.table_row{
  padding:12px 16px;
  border-bottom:1px solid #E4E7EC;
}

.table_row:last-child{
  border-bottom:none;
}

/* Hover effect */
.table_row:hover{
  background:#F9FAFB;
}

/* Reveal link */
.reveal{
  margin-left:8px;
  color:#3182CE;
  cursor:pointer;
  font-size:13px;
  font-weight:500;
}

`;

export default MyDiv;